import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../types/referrer/store';
import {
  fetchSendValidationCode,
  TSendValidationCodeResponse,
} from '../../../repositories/sms/v2/send-validation-code';
import { EType } from '../../../repositories/sms/entities/PublicValidationCode/PublicSendValidationCodeRequest';
import { setModalError, setModalStatus, setUserPhoneNumber } from '../../../slices';
import { EModalStatus } from '../../../types/referrer/page';

export const requestPhoneValidationCode = createAsyncThunk<void, string, IThunkApi>(
  'auth/sendCode',
  async (phone, _thunkApi) => {
    const {
      dispatch,
      extra: { httpApi, logger },
    } = _thunkApi;

    try {
      dispatch(setModalError(''));
      const res = (await fetchSendValidationCode({
        httpApi,
        parameters: {
          type: EType.PhoneNumber,
          phone: `+7${phone}`,
        },
      })) as TSendValidationCodeResponse;

      // @ts-ignore
      if (res.statusCode === 400) {
        dispatch(setModalError(res.response));

        return;
      }

      if (res.statusCode === 200) {
        dispatch(setUserPhoneNumber(phone));
        dispatch(setModalStatus(EModalStatus.SendVerificationCode));

        return;
      }

      dispatch(setModalStatus(EModalStatus.Error));

      return;
    } catch (e) {
      logger.debug('Ошибка получения кода подтверждения', {
        message: e.message,
        domain: e.domain,
      });

      dispatch(setModalStatus(EModalStatus.Error));

      return;
    }
  },
);
